module.exports = __webpack_public_path__ + "img/安全、盾、验证码.f15487a3.png";